import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import * as _ from 'lodash';

import { FADE_IN_OUT_ANIMATION } from '@shared/animations';
import { Sort, Language, ParseObject, Job } from '@shared/data';
import { JobQuery } from '@shared/queries';
import { CrudService, LanguageService } from '@shared/services';
import { LoadingService } from '@shared/modules/loading';

import { JobListDataTableOptions } from './job-list.data-table-option';

@Component({
  moduleId: 'module.id',
  selector: 'job-list',
  styles: [require('./job-list.component.scss')],
  template: require('./job-list.component.html'),
  animations: [FADE_IN_OUT_ANIMATION]
})
export class JobListComponent implements OnInit {
  public jobs: Job[];
  public error: Parse.Error;
  public options: JobListDataTableOptions;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private loadingService: LoadingService,
    private languageService: LanguageService) {

    this.options = new JobListDataTableOptions();
    this.jobs = [];
  }

  // ===============================================================================================
  // Override Methods
  // ===============================================================================================

  public ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.fetchJobs();
    });
  }

  // ===============================================================================================
  // Actions
  // ===============================================================================================

  public onRowSelect(row: number) {
    this.router.navigate(['edit', this.jobs[row].id], {
       relativeTo: this.route
    });
  }

  public onDelete(row: number): void {
    let job = this.jobs.splice(row, 1)[0];

    this.loadingService.continue();

    job.destroy().then(
      result => {
        this.fetchJobs();
      },
      error => {
        this.error = error;
        this.loadingService.complete();
      }
    );
  }

  public onDrop(evt) {
    let drag = this.jobs[evt.dragIndex];
    let drop = this.jobs[evt.dropIndex];
    let temp = drag.sortOrder;

    drag.sortOrder = drop.sortOrder;
    drop.sortOrder = temp;

    this.loadingService.continue();

    Parse.Object.saveAll([drag, drop]).then(
      result => {
        this.loadingService.complete();
        this.jobs = _.sortBy(this.jobs, e => e.sortOrder);
      },
      error => {
        this.error = error;
        this.loadingService.complete();
        this.jobs = _.sortBy(this.jobs, e => e.sortOrder);
      }
    )
  }

  // ===============================================================================================
  // Private Methods
  // ===============================================================================================

  private fetchJobs(): void {
    let lang = this.languageService.defaultLang;
    let query = new JobQuery()
      .addAscending(Job.SORT_ORDER_KEY);

    this.loadingService.continue();

    query.find().then(
      result => {
        this.jobs = result;
        this.loadingService.complete();
      },
      error => {
        this.error = error;
        this.loadingService.complete();
      }
    );
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+admin/modules/+job/job-list/job-list.component.ts